import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Stack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import useResponsive from "../../util/useResponsive";
import Paper from "../../atoms/Paper";
import Headline from "../../molecules/Headline";
import DeviceCard from "../../organisms/DeviceCard";
import { useDevices } from "../../providers/device";
import ButtonLink from "../../atoms/ButtonLink";
const Devices = () => {
    const { devices } = useDevices();
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    return devices.length ? (_jsxs(Paper, { children: [_jsx(Headline, { title: t("devices"), size: "xs", py: isSmallScreen ? 0 : 6, rightContent: _jsx(ButtonLink, Object.assign({ size: "sm", variant: "link", p: 0, route: "devices_connected", params: {} }, { children: t("editDevices") })) }), _jsx(Stack, Object.assign({ direction: {
                    md: "column",
                    lg: "row",
                }, p: 4, width: "full", space: isSmallScreen ? 2 : 0, divider: isSmallScreen ? _jsx(Divider, {}) : undefined, flexWrap: "wrap" }, { children: devices.map((device) => (_jsx(Box, Object.assign({ width: {
                        md: "full",
                        lg: "1/2",
                        xl: "1/3",
                    }, 
                    // px={isSmallScreen ? 4 : 0}
                    p: 1 }, { children: _jsx(DeviceCard, { device: device }) }), device.provider))) }))] })) : null;
};
export default Devices;
